module.exports = __webpack_public_path__ + "static/images/cover_C13.ed6516d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_C13.png
// module id = rNqw
// module chunks = 8